import React from "react";
import { Link } from "react-router-dom";
import {
  IconUser,
  IconBuilding,
  IconExternalLink,
  IconUsers,
} from "@tabler/icons-react";
import { Button, Flex, Text, Stack } from "@mantine/core";
import { ResendInvite } from "@components/Request";
import "./index.scss";

const iconStyles = {
  size: 50,
};

export default function Summary({
  showResend,
  surveys,
  surveyName,
  companyName,
  companyId,
}) {
  return (
    <div className="request-summary">
      <Stack gap="xl">
        <Flex gap="xs" align="center">
          <IconBuilding {...iconStyles} />
          <div>
            <Flex gap="xs" align="center">
              <Text fw={700}>{companyName}</Text>
              {companyId && (
                <Link to={`/companies/${companyId}`}>
                  <IconExternalLink size={16} />
                </Link>
              )}
            </Flex>
            <Text>Company</Text>
          </div>
        </Flex>
        {surveyName && (
          <Flex gap="xs" align="center">
            <IconUsers {...iconStyles} />
            <Flex gap="xs" align="center">
              <Text fw={700}>{surveyName}</Text>
              <Text>Engagement Survey</Text>
            </Flex>
          </Flex>
        )}
        {surveys.map((s) => (
          <Flex gap="xs" align="center">
            <IconUser {...iconStyles} className="user-icon" />
            <div>
              <Flex gap="xs" align="center">
                <Text fw={700}>
                  {s.company_manager_name && `${s.company_manager_name}`}
                  {s.company_employee_name && `${s.company_employee_name}`}
                  {s.company_manager &&
                    `${s.company_manager.first_name} ${s.company_manager.last_name} (Manager)`}
                  {s.company_employee &&
                    `${s.company_employee.first_name} ${s.company_employee.last_name} (Employee)`}
                  {s.target && <span className="rater-tag">target</span>}
                  {!s.target && s.rater_type && (
                    <span className="rater-tag">
                      {s.rater_type}
                      {s.other_rater_context && `: ${s.other_rater_context}`}
                    </span>
                  )}
                </Text>
                {showResend && (
                  <span style={{ marginLeft: "10px" }}>
                    <ResendInvite id={s.id} title={s.name} />
                  </span>
                )}
              </Flex>
              <Text>{s.name}</Text>
              {s.company_manager && <Text>{s.company_manager.email}</Text>}
              {s.company_employee && <Text>{s.company_employee.email}</Text>}
              {s.email && <Text>{s.email}</Text>}
            </div>
          </Flex>
        ))}
      </Stack>
    </div>
  );
}

Summary.defaultProps = {
  companyId: null,
  companyName: "",
  showResend: false,
  surveys: [],
  surveyName: "",
};

// Summary.propTypes = {
//   companyName: PropTypes.string,
//   surveys: PropTypes.array,
// };
